const getIdByName = async (
  bannerPage: { name: string; id: string }[],
  name: string
) => {
  const item = bannerPage.find((item) => item.name === name);
  return item ? item.id : undefined;
};

export default getIdByName;
